<template>
  <v-dialog
    v-model="computedSnowmakingPotablesVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn icon @click="methodToggleListView('snowmaking', 'potable')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="hidden-sm-and-down"
          >Potable Water</v-toolbar-title
        >
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-text-field
          style="margin-top: -10px;"
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter data"
        ></v-text-field>
        <v-spacer class="hidden-sm-and-down"></v-spacer>

        <v-btn
          v-if="
            computedAuthProfile === 'admin' ||
              computedAuthProfile === 'maintenance'
          "
          icon
          @click.stop="methodDownloadCSV()"
        >
          <v-icon>get_app</v-icon>
        </v-btn>
        <!--
        <v-btn icon @click.stop="addPotable = true">
          <v-icon>add</v-icon>
        </v-btn>
        -->
      </v-toolbar>
      <div
        style="
          background-color: black;
          padding-left: 30px;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        "
      >
        <v-data-table
          :headers="headers"
          :items="computedSnowmakingPotableGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
          :loading="computedSnowmakingPotablesLoading"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="
                methodToggleSingleLayer(
                  'snowmaking',
                  'potable',
                  true,
                  props.item.properties.id
                )
              "
            >
              <td>{{ props.item.properties.mountain }}</td>
              <td>{{ props.item.properties.pipe_name }}</td>
              <td>{{ props.item.properties.pipe_type }}</td>
              <td>{{ props.item.properties.diam_in }}</td>
              <td>{{ props.item.properties.length_m }}</td>
              <td>{{ props.item.properties.extent }}</td>
              <td>{{ props.item.properties.comments }}</td>
              <td>{{ props.item.properties.coll_date }}</td>
              <td>{{ props.item.properties.coll_device }}</td>
              <td>{{ props.item.properties.install_da }}</td>
              <td>{{ props.item.properties.install_by }}</td>
            </tr>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
import { parse } from "json2csv";
export default {
  data() {
    return {
      rows_per_page: [
        10,
        25,
        50,
        {
          text: "All",
          value: -1
        }
      ],
      rows_per_page_text: "Per page:",
      loading: true,
      search: "",
      headers: [
        {
          text: "Mountain",
          value: "properties.mountain"
        },
        {
          text: "Pipe Name",
          value: "properties.pipe_name"
        },
        {
          text: "Pipe Type",
          value: "properties.pipe_type"
        },
        {
          text: "Diameter (in)",
          value: "properties.diam_in"
        },
        {
          text: "Length (m)",
          value: "properties.length_m"
        },
        {
          text: "Extent",
          value: "properties.extent"
        },
        {
          text: "Comments",
          value: "properties.comments"
        },
        {
          text: "Collection Date",
          value: "properties.coll_date"
        },
        {
          text: "Collection Device",
          value: "properties.coll_device"
        },
        {
          text: "Installation Date",
          value: "properties.install_da"
        },
        {
          text: "Installed By",
          value: "properties.install_by"
        }
      ]
    };
  },
  computed: {
    computedSnowmakingPotableGeoJsonFeatures() {
      return this.$store.state.mapLayers.snowmaking.layers.potable.geojson
        .features;
    },
    computedSnowmakingPotablesVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.potable.visibility
        .listView;
    },
    computedSnowmakingPotablesLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.potable.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodDownloadCSV() {
      const fields = [
        {
          text: "Mountain",
          value: "properties.mountain"
        },
        {
          text: "Pipe Name",
          value: "properties.pipe_name"
        },
        {
          text: "Pipe Type",
          value: "properties.pipe_type"
        },
        {
          text: "Diameter (in)",
          value: "properties.diam_in"
        },
        {
          text: "Length (m)",
          value: "properties.length_m"
        },
        {
          text: "Extent",
          value: "properties.extent"
        },
        {
          text: "Comments",
          value: "properties.comments"
        },
        {
          text: "Collection Date",
          value: "properties.coll_date"
        },
        {
          text: "Collection Device",
          value: "properties.coll_device"
        },
        {
          text: "Installation Date",
          value: "properties.install_da"
        },
        {
          text: "Installed By",
          value: "properties.install_by"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.snowmaking.layers.potable.geojson
            .features,
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "snowmaking_potable.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    },

    // method to get geojson
    methodGetSnowmakingPotablesGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/snowmaking/potable",
        dept: "snowmaking",
        layer: "potable",
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.potable.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSnowmakingPotablesGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.potable.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
